const APP_BRIDGE_SRC = 'https://cdn.shopify.com/shopifycloud/app-bridge.js';

export function isInsideShopifyAdmin(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

export function loadAppBridge(apiKey: string, timeoutMs = 3000): Promise<void> {
  if (typeof window.shopify?.idToken === 'function') {
    return Promise.resolve();
  }

  const meta = document.createElement('meta');
  meta.name = 'shopify-api-key';
  meta.content = apiKey;
  document.head.appendChild(meta);

  return new Promise((resolve) => {
    const script = document.createElement('script');
    script.src = APP_BRIDGE_SRC;
    script.async = false;
    const timer = window.setTimeout(() => resolve(), timeoutMs);
    const done = () => {
      window.clearTimeout(timer);
      resolve();
    };
    script.onload = done;
    script.onerror = done;
    document.head.appendChild(script);
  });
}

export async function tryGetShopifyIdToken(timeoutMs = 1500): Promise<string | null> {
  const bridge = window.shopify;
  if (!bridge || typeof bridge.idToken !== 'function') {
    return null;
  }

  try {
    const token = await Promise.race([
      bridge.idToken(),
      new Promise<null>((resolve) => setTimeout(() => resolve(null), timeoutMs)),
    ]);
    return typeof token === 'string' && token.length > 0 ? token : null;
  } catch {
    return null;
  }
}

export function isShopifyBridgePresent(): boolean {
  return typeof window.shopify?.idToken === 'function';
}
